module.exports = __webpack_public_path__ + "img/howItWorksMobile.e793f9ed.png";